import { Action, createReducer, on } from "@ngrx/store";
import { IConsumableWarehouseState } from "./consumable-warehouse";
import { APPROVVIGIONAMENTO_ORDINE_FINALE_SUCCESS, APPROVVIGIONAMENTO_ORDINE_SUCCESS, APPROVVIGIONAMENTO_PRODOTTI_SUCCESS, CATALOGO_APPARTENENZA_RESO_SUCCESS, CATALOGO_APPARTENENZA_SUCCESS, CREA_RESO_SUCCESS, ESPORTA_STORICO_ORDINI_SUCCESS, GENERTE_BARCODE_SCATOLA_RESO_SUCCESS, MAIL_STORICO_ORDINI_SUCCESS, PRODOTTI_RESO_SUCCESS, RETRIEVE_PRODUCTS_BOX_ACCEPTANCE_SUCCESS, STORICO_ORDINI_MATERIALI_SUCCESS } from "./consumable-warehouse.actions";
import { ICatalogoAppartenenzaResoResponse, ICatalogoAppartenenzaResponse, IProdottiResoResponse, IProductsBoxAcceptance } from "../../interfaces/catalogo-appartenenza";
import { IResponseApprovvigionamentoOrdine, IResponseApprovvigionamentoOrdineFinale, IResponseApprovvigionamentoProdotti } from "../../interfaces/approvvigionamento-ordine";
import { IResponseGenerateBarcodeReso } from "../../interfaces/generate-barcode-scatola-reso";
import { IResponseStoricoOrdiniMateriali } from "../../interfaces/storico-ordini-materiali";

/* INITIAL STATE */
const initialState: IConsumableWarehouseState = {
  responseCatalogoAppartenenza: null,
  responseApprovvigionamentoOrdine: null,
  responseApprovvigionamentoProdotti: null,
  responseApprovvigionamentoOrdineFinale: null,
  responseCatalogoAppartenenzaReso: null,
  responseProdottiReso: null,
  responseGenerateBarcodeScatolaReso: null,
  responseCreaReso: null,
  responseStoricoOrdiniMateriali: null,
  responseEsportaStoricoOrdini: null,
  responseMailStoricoOrdini: null,
  responseProductsBoxAcceptance: null,
};

const handleCatalogoAppartenenza = (
  state: IConsumableWarehouseState,
  { responseCatalogoAppartenenza }: { responseCatalogoAppartenenza: ICatalogoAppartenenzaResponse | null }
): IConsumableWarehouseState => {
  return {
    ...state,
    responseCatalogoAppartenenza,
  };
};

const handleApprovvigionamentoOrdine = (
  state: IConsumableWarehouseState,
  { responseApprovvigionamentoOrdine }: { responseApprovvigionamentoOrdine: IResponseApprovvigionamentoOrdine | null }
): IConsumableWarehouseState => {
  return {
    ...state,
    responseApprovvigionamentoOrdine,
  };
};

const handleApprovvigionamentoProdotti = (
  state: IConsumableWarehouseState,
  { responseApprovvigionamentoProdotti }: { responseApprovvigionamentoProdotti: IResponseApprovvigionamentoProdotti | null }
): IConsumableWarehouseState => {
  return {
    ...state,
    responseApprovvigionamentoProdotti,
  };
};

const handleApprovvigionamentoOrdineFinale = (
  state: IConsumableWarehouseState,
  { responseApprovvigionamentoOrdineFinale }: { responseApprovvigionamentoOrdineFinale: IResponseApprovvigionamentoOrdineFinale | null }
): IConsumableWarehouseState => {
  return {
    ...state,
    responseApprovvigionamentoOrdineFinale,
  };
};

const handleCatalogoAppartenenzaReso = (
  state: IConsumableWarehouseState,
  { responseCatalogoAppartenenzaReso }: { responseCatalogoAppartenenzaReso: ICatalogoAppartenenzaResoResponse | null }
): IConsumableWarehouseState => {
  return {
    ...state,
    responseCatalogoAppartenenzaReso,
  };
};

const handleProdottiReso = (
  state: IConsumableWarehouseState,
  { responseProdottiReso }: { responseProdottiReso: IProdottiResoResponse | null }
): IConsumableWarehouseState => {
  return {
    ...state,
    responseProdottiReso,
  };
};

const handleGenerateBarcodeReso = (
  state: IConsumableWarehouseState,
  { responseGenerateBarcodeScatolaReso }: { responseGenerateBarcodeScatolaReso: IResponseGenerateBarcodeReso | null }
): IConsumableWarehouseState => {
  return {
    ...state,
    responseGenerateBarcodeScatolaReso,
  };
};

const handleCreaReso = (
  state: IConsumableWarehouseState,
  { responseCreaReso }: { responseCreaReso: IResponseGenerateBarcodeReso | null }
): IConsumableWarehouseState => {
  return {
    ...state,
    responseCreaReso,
  };
};

const handleStoricoOrdiniMateriali = (
  state: IConsumableWarehouseState,
  { responseStoricoOrdiniMateriali }: { responseStoricoOrdiniMateriali: IResponseStoricoOrdiniMateriali | null }
): IConsumableWarehouseState => {
  return {
    ...state,
    responseStoricoOrdiniMateriali,
  };
};

const handleEsportaStoricoOrdini = (
  state: IConsumableWarehouseState,
  { responseEsportaStoricoOrdini }: { responseEsportaStoricoOrdini: any }
): IConsumableWarehouseState => {
  return {
    ...state,
    responseEsportaStoricoOrdini,
  };
};

const handleMailStoricoOrdini = (
  state: IConsumableWarehouseState,
  { responseMailStoricoOrdini }: { responseMailStoricoOrdini: IResponseStoricoOrdiniMateriali | null }
): IConsumableWarehouseState => {
  return {
    ...state,
    responseMailStoricoOrdini,
  };
};

const handleRetrieveProductsBoxAcceptance = (
  state: IConsumableWarehouseState,
  { responseProductsBoxAcceptance }: { responseProductsBoxAcceptance: IProductsBoxAcceptance | null }
): IConsumableWarehouseState => {
  return {
    ...state,
    responseProductsBoxAcceptance
  };
};

/* REDUCER */
export const reducer = createReducer(
  initialState,
  on(CATALOGO_APPARTENENZA_SUCCESS, handleCatalogoAppartenenza),
  on(APPROVVIGIONAMENTO_ORDINE_SUCCESS, handleApprovvigionamentoOrdine),
  on(APPROVVIGIONAMENTO_PRODOTTI_SUCCESS, handleApprovvigionamentoProdotti),
  on(APPROVVIGIONAMENTO_ORDINE_FINALE_SUCCESS, handleApprovvigionamentoOrdineFinale),
  on(CATALOGO_APPARTENENZA_RESO_SUCCESS, handleCatalogoAppartenenzaReso),
  on(PRODOTTI_RESO_SUCCESS, handleProdottiReso),
  on(GENERTE_BARCODE_SCATOLA_RESO_SUCCESS, handleGenerateBarcodeReso),
  on(CREA_RESO_SUCCESS, handleCreaReso),
  on(STORICO_ORDINI_MATERIALI_SUCCESS, handleStoricoOrdiniMateriali),
  on(ESPORTA_STORICO_ORDINI_SUCCESS, handleEsportaStoricoOrdini),
  on(MAIL_STORICO_ORDINI_SUCCESS, handleMailStoricoOrdini),
  on(RETRIEVE_PRODUCTS_BOX_ACCEPTANCE_SUCCESS, handleRetrieveProductsBoxAcceptance)
);

export const consumableWarehouseReducer = (
  state: IConsumableWarehouseState | undefined,
  action: Action
): IConsumableWarehouseState => reducer(state, action);
